import React from 'react'
import banner from 'assets/images/banner.png'

function Banner() {
    return (
        <div className="login-banner">
            <img src={banner} alt="IMG" />
        </div>
    )
}

export default Banner;


// WEBPACK FOOTER //
// ./src/components/elements/Banner/Banner.js